import { connect } from 'react-redux';
import Appointment from './Appointment';
import {
    getAppointmentList,
    getAppointmentListLoadingStatus,
    getPersonAppointmentColumnFields,
} from '../../../../store/selectors/person.selectors';
import { getAuthenticationToken } from '../../../../store/actions/authentication.actions';
import { deleteAppointmentRecordBegin } from '../..../../../../../store/actions/person.actions';

const mapStateToProps = (state: any) => {
    const data = getAppointmentList(state);
    const loading = getAppointmentListLoadingStatus(state);
    const appointmentColumns = getPersonAppointmentColumnFields(state);

    return { data, loading, appointmentColumns };
};
const mapDispatchToProps = {
    getAuthenticationToken: getAuthenticationToken,
    deleteAppointment: deleteAppointmentRecordBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(Appointment);
